/* TODO: This should be pulled from theme not constants */
export const fontSizeSmall = '14px';
export const fontSizeStandard = '16px';
export const fontSizeBig = '20px';

export const fontSizeBigger = '24px';
export const fontSizeHuge = '46px';
